import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResumeDataByID } from '@edtech-ui/core/models/resume-builder/get-resume-by-id';

@Component({
  selector: 'app-creative-template',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './creative-template.component.html',
  styleUrl: './creative-template.component.scss'
})
export class CreativeTemplateComponent {
  @Input() data!: ResumeDataByID;
  @Input() color: string = '#4f46e5';
  @Input() font: string = 'Inter'

}
